import React from 'react';
import styled from '@emotion/styled';
import { Theme } from 'ui_system/theme';
import { t } from 'services/translation';

const FooterStyled = styled.footer`
  color: ${Theme.colors.black};

  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
`;

const Links = styled.div`
  margin-top: 10px;
  a {
    color: ${Theme.colors.lightText};
    margin: 0px 5px;
    text-decoration: underline;
  }
`;

const Dot = styled.span`
  height: 5px;
  width: 5px;
  background-color: ${Theme.colors.lightText};
  border-radius: 50%;
  display: inline-block;
  margin-bottom: 2px;
`;

const GrayLink = styled.a`
  color: ${Theme.colors.gray};
`;

const Border = styled.div`
  padding: 12px 32px;
  border-top: 1px solid ${Theme.colors.mediumBackground};
`;

export const FormFooter = () => {
  return (
    <FooterStyled>
      <Border />
      <div>
        {t('POWERED_BY')}{' '}
        <GrayLink
          href="https://www.anyroad.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          AnyRoad
        </GrayLink>
      </div>
      <Links>
        <a
          href="https://www.anyroad.com/end-user-terms"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('TERMS_OF_SERVICE')}
        </a>{' '}
        <Dot />{' '}
        <a
          href="https://www.anyroad.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('PRIVACY_POLICY')}
        </a>
      </Links>
    </FooterStyled>
  );
};
